import { useMemo } from "react";

import CrmEnrichmentJobRemoveModalContainer from "app/pages/sales-intelligence/modules/crm-enrichment/impl/hubspot/containers/CrmEnrichmentJobRemoveModalContainer/CrmEnrichmentJobRemoveModalContainer";
import CrmEnrichmentJobRenameModalContainer from "app/pages/sales-intelligence/modules/crm-enrichment/impl/hubspot/containers/CrmEnrichmentJobRenameModalContainer/CrmEnrichmentJobRenameModalContainer";
import HsEnrichmentJobToggle from "app/pages/sales-intelligence/modules/crm-enrichment/impl/hubspot/containers/HsEnrichmentJobToggle/HsEnrichmentJobToggle";
import useHsEnrichmentJobsQuery from "app/pages/sales-intelligence/modules/crm-enrichment/impl/hubspot/queries/useHsEnrichmentJobsQuery";
import type { Integration } from "app/pages/sales-intelligence/sub-modules/management/types";

import BaseEnrichmentPreferences from "../../components/BaseEnrichmentPreferences/BaseEnrichmentPreferences";
import type { EnrichmentPreferencesSlots } from "../../components/BaseEnrichmentPreferences/types";
import HubsportEnrichmentEmptyState from "../EnrichmentEmptyState/HubsportEnrichmentEmptyState";

type Props = {
    integrationName: Integration;
    isMappingLoading: boolean;
    onEditMapping: VoidFunction;
};

const HsEnrichmentPreferences = ({ integrationName, onEditMapping, isMappingLoading }: Props) => {
    const queryResult = useHsEnrichmentJobsQuery({ polling: true });

    const slots: EnrichmentPreferencesSlots = useMemo(
        () => ({
            renderJobToggle: ({ job, onRenameClick, onDeleteClick }) => (
                <HsEnrichmentJobToggle
                    key={job.id}
                    job={job}
                    onRenameClick={onRenameClick}
                    onDeleteClick={onDeleteClick}
                />
            ),
            renderModals: ({ activeJob, onClearActiveJob }) => (
                <>
                    <CrmEnrichmentJobRenameModalContainer
                        job={activeJob}
                        onClose={onClearActiveJob}
                    />
                    <CrmEnrichmentJobRemoveModalContainer
                        job={activeJob}
                        onClose={onClearActiveJob}
                    />
                </>
            ),
            renderEmptyState: (emptyStateProps) => (
                <HubsportEnrichmentEmptyState
                    isMappingLoading={emptyStateProps.isMappingLoading}
                    isDisabledAddButton={emptyStateProps.isCreateJobDisabled}
                    onClickAddJob={emptyStateProps.onClickAddJob}
                    onEditMapping={emptyStateProps.onEditMapping}
                />
            ),
        }),
        [],
    );

    return (
        <BaseEnrichmentPreferences
            integrationName={integrationName}
            isMappingLoading={isMappingLoading}
            queryResult={queryResult}
            slots={slots}
            onEditMapping={onEditMapping}
        />
    );
};

export default HsEnrichmentPreferences;
